<template>
    <div class="event-screen activity w-100 h-100 overflow-hidden d-flex flex-column">
        <div class="custom-background" :style="{ backgroundImage: `url('${$store.state.game.images?.activity_image}')`}"></div>
        <template v-if="$store.state.game.question">
            <div :class="'d-flex flex-column h-100 w-100' + ((title == true) ? ' d-none' : '')">
                <PlayerTopbar>
                    <StageProgress v-if="progress" :types="progress.types" :index="progress.index" :completed="true" :color="own_jersey_color || undefined" />
                </PlayerTopbar>
                <div class="flex-fill overflow-auto p-4" id="question-bg">
                    <div v-if="$store.state.game.user.role == utils.USER_ROLES.PLAYER && own_result.answered && !utils.is_content_activity($store.state.game.question.question.type)" :class="'feedback-banner mb-4 ' + (own_result.correct ? 'feedback-correct' : 'feedback-incorrect')">
                        <i :class="'bi feedback-icon ' + (own_result.correct ? 'bi-check-circle-fill' : 'bi-x-circle-fill')"></i>
                        <div class="feedback-headline">{{ own_result.correct ? '¡Respuesta correcta!' : 'Respuesta incorrecta' }}</div>
                        <div class="feedback-points" v-if="own_result.correct">+{{ Math.round(own_result.score) }} <small>puntos</small></div>
                    </div>
                    <div id="text-region" class="animate__animated animate__fadeInDown" v-html="format_title($store.state.game.question.question.title)"></div>
                    <FeedbackContent class="mt-4" :value="$store.state.game.question.question.feedback" />
                    <div id="question-body" class="w-100 mt-4">
                        <template v-if="$store.state.game.question.question.type == utils.ACTIVITY_TYPE.QUIZ || $store.state.game.question.question.type == utils.ACTIVITY_TYPE.QUIZ_MULTIPLE">
                            <quiz-act></quiz-act>
                        </template>
                        <template v-if="$store.state.game.question.question.type == utils.ACTIVITY_TYPE.CROSSWORD">
                            <cross-word-act></cross-word-act>
                        </template>
                        <template v-if="$store.state.game.question.question.type == utils.ACTIVITY_TYPE.TEXT">
                            <text-act></text-act>
                        </template>
                        <template v-if="$store.state.game.question.question.type == utils.ACTIVITY_TYPE.TRUE_FALSE">
                            <true-false-act></true-false-act>
                        </template>
                        <template v-if="$store.state.game.question.question.type == utils.ACTIVITY_TYPE.RANGE">
                            <range-act></range-act>
                        </template>
                    </div>
                </div>
                <PlayerFooter />
            </div>
            <div v-if="title == true" class="position-absolute top-0 start-0 w-100 h-100 p-1 title-modal-bg">
                <div  class="row m-0 h-100 d-flex justify-content-center align-items-center animate__animated animate__fadeInDown">
                    <div class="d-flex justify-content-center align-items-center flex-column">
                        <span id="title-text-modal" class="text-center">{{ $store.state.game.question.question.title }}</span>
                        <div v-if="$store.state.game.question.question.type == utils.ACTIVITY_TYPE.CROSSWORD" class="col-8">
                            <p class="title-choice text-white" v-for="(choice, idx) in $store.state.game.question.question.choices">{{ idx+1 }}.- {{ choice }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <div class="modal fade p-3" id="previewImageModal" tabindex="-1" aria-labelledby="previewImageModal" aria-hidden="true">
            <div class="modal-dialog modal-fullscreen w-100 h-100">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5 text-black" id="previewImageModal">Imagen</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body bg-dark bg-opacity-25 w-100 h-100 d-flex justify-content-center align-items-center">
                        <div class="w-100 h-100 d-flex justify-content-center align-items-start">
                            <img class="img-fluid" :src="preview_img">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PlayerTopbar from '@/components/PlayerTopbar.vue'
import PlayerFooter from '@/components/PlayerFooter.vue'
import FeedbackContent from '@/components/FeedbackContent.vue';
import QuizAct from '@/components/type/Quiz.vue';
import CrossWordAct from '@/components/type/CrossWord.vue';
import TextAct from '@/components/type/Text.vue';
import TrueFalseAct from '@/components/type/TrueFalse.vue';
import RangeAct from '@/components/type/Range.vue';
import StageProgress from '@/components/StageProgress.vue'
import { stageProgress } from '@/utils/stage-progress'

export default {
    name: 'Result',
    components: {
        PlayerTopbar,
        PlayerFooter,
        FeedbackContent,
        QuizAct,
        CrossWordAct,
        TextAct,
        TrueFalseAct,
        RangeAct,
        StageProgress
    },
    data(){
        return {
            utils: require('../../../shared/utils'),
            title: false,
            preview_img: null,
            img_preview: false,
        };
    },
    computed : {
        // Where we are in the current stage - see utils/stage-progress.js.
        progress(){
            return stageProgress(this.$store.state.game);
        },
        own_jersey_color(){
            const user = this.$store.state.game.user;
            return (user && user.avatar_style && user.avatar_style.color) || null;
        },
        own_result(){
            var question = this.$store.state.game.question;
            if(!question) return { answered: false, correct: false, score: 0 };
            return this.utils.calc_question_result(this.$store.state.game.user.data, question.question.id);
        }
    },
    mounted(){
        if(window.store.state.network == "connected")
            window.network.wso.send(JSON.stringify({action: window.RPC.UPDATE_VIEW, params: {view: window.router.currentRoute._value.name, activity: (window.store.state.game.question) ? window.store.state.game.question.id : null}}))

        $('.modal-backdrop').remove();
    },
    methods:{
        toggle_imgpreview(){
            this.img_preview = !this.img_preview;
        },
        format_title(title){
            // Expresión regular para encontrar enlaces en el texto
            const regex = /https?:\/\/[^\s]+/g;

            // Reemplazar enlaces en el texto con botones
            const textoConBoton = title.replace(regex, (match) => {
                this.preview_img = match;
                return `<button type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#previewImageModal">ver imagen</button>`;
            });

            $('#preview-img').click(function(){
                this.toggle_imgpreview();
            }.bind(this));

            return textoConBoton;
        },
    }
}
</script>

<style scoped>
    .activity{
        background-color: var(--vc-paper-200);
    }

    #logos img{
        max-height: 32px;
    }

    /* Bottom clearance so the last line clears the team card floating
       over the footer (same as Activity.vue). */
    #question-bg{
        border-radius: 0;
        padding-bottom: 6rem !important;
    }

    .animate__delay-0-5s
    {
        --animate-delay: 0.5s;
    }

    #title-text-modal{
        font-family: "Public Sans", sans-serif; font-weight: 700;
        font-size: 2.5vw !important;
        color: var(--vc-paper-50) !important;
    }

    /* Correct/incorrect banner. The right answer itself is already marked
       in the answers below, so this only says how it went (+ points).
       Phones: one compact row; wider screens: stacked and centred. */
    .feedback-banner{
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 10px 16px;
        border-radius: 12px;
    }

    .feedback-icon{
        font-size: 1.8rem;
        line-height: 1;
    }

    .feedback-headline{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 1.05rem;
        line-height: 1.15;
        text-transform: uppercase;
    }

    .feedback-points{
        margin-left: auto;
        font-family: "Archivo", sans-serif;
        font-weight: 900;
        font-size: 1.4rem;
        white-space: nowrap;
    }
    .feedback-points small{
        font-family: "Public Sans", sans-serif;
        font-weight: 700;
        font-size: 0.75rem;
        text-transform: uppercase;
    }

    @media (min-width: 768px){
        .feedback-banner{
            flex-direction: column;
            gap: 6px;
            padding: 20px;
            text-align: center;
        }
        .feedback-icon{ font-size: 2.6rem; }
        .feedback-headline{ font-size: 1.4rem; }
        .feedback-points{ margin-left: 0; font-size: 2rem; }
        .feedback-points small{ font-size: 0.9rem; }
    }

    .feedback-correct{
        background-color: var(--vc-success-100);
    }
    .feedback-correct .feedback-icon,
    .feedback-correct .feedback-headline,
    .feedback-correct .feedback-points{
        color: var(--vc-success-500);
    }

    .feedback-incorrect{
        background-color: var(--vc-danger-100);
    }
    .feedback-incorrect .feedback-icon,
    .feedback-incorrect .feedback-headline{
        color: var(--vc-danger-500);
    }
</style>
